export const REGISTER_BUTTON_CLICK = 'RegisterButton click'
export const REGISTER_2_BUTTON_CLICK = 'Register2Button click'
export const REGISTER_3_BUTTON_CLICK = 'Register3Button click'
export const APPLY_EXTERNAL_BTN_CLK = 'Apply on external website button click'
export const SEE_MORE_MEMBERSHIP_OPT_CLK = 'See More Membership Options Click'
export const PACKAGE_BTN_CLK = 'PackageButton click'
export const PAYMENT_MODAL_OPEN = 'PaymentPopup open'
export const PAYMENT_MODAL_CLOSE = 'PaymentPopup closed'
export const PAYMENT_REDIRECT = 'PaymentRedirect'
export const PAYMENT_BTN_CLK = 'PaymentPopupForm Button Click'
/**
 * @deprecated https://app.clickup.com/t/36184932/SD-8000
 */
export const APPLICATION_SENT = 'Application Sent'
export const SORTING_APPLIED = 'Sorting Applied'
export const SCHOLARSHIP_CARD_PICK = 'Scholarship Card Pick'
export const SCHOLARSHIP_CARD_UNPICK = 'Scholarship Card Unpick'
export const SCHOLARSHIP_CARD_IGNORE = ' Scholarship Card Ignore'
export const SCHOLARSHIP_CARD_UNIGNORE = ' Scholarship Card Unignore'
export const SCHOLARSHIP_DETAILS_VIEW = 'Scholarship Details View'
export const SUBMITTED_APPLICATION_DETAILS_VIEW = 'Submitted Application Details View'
export const COMPLETE_APPLICATION_BUTTON_CLICK_STARTED_APPLICATIONS = 'Complete Application Button Click Started Applications'
export const EDIT_APPLICATION_BUTTON_CLICK_STARTED_APPLICATIONS = 'Edit Application Button Click Started Applications'
export const APPLY_FOR_SCHOLARSHIP_BUTTON_CLICK_STARTED_APPLICATIONS = 'Apply For Scholarship Button Click Started Applications'
export const CLAIM_AWARD_BUTTON_CLICK_SUBMITTED_APPLICATIONS = 'Claim Award Button Click Submitted Applications'
export const TAB_CHANGE = 'Tab Change'
export const DEADLINE_FILTER_APPLIED = 'Deadline Filter Applied'
export const AMOUNT_FILTER_APPLIE = 'Amount Filter Applied'
export const REQUIREMENT_FILTER_APPLIED = 'Requirement Type Filter Applied'
export const REQUIREMENT_WRITE = 'Requirement Write'
export const APPLICATION_FILTER_APPLIED = 'Applicant Number Filter Applied'
export const PAYMENT_FILTER_APPLIED = 'Payout Filter Applied'
export const CONFIDENCE_SCORE_FILETER_APPLIED = 'Confidence Score Filter Applied'
export const SEARCH_APPLIED = 'Search Applied'
export const SCHOLARSHIP_CARD_REPORT = 'Scholarship Card Report'
export const RECOMMENDED_SUCCESS = 'Recommended Success'
export const EMAIL_LOGIN = 'Email Login'
export const FB_LOGIN = 'FB Login'
export const PROVIDER_URL_VISIT = "Scholarship provider's URL visit"
export const SCHOLARSHIP_CARD_CLICK = 'Scholarship card click'
export const SIMILAR_SCHOLARSHIPS_BUTTON_CLICK = 'Apply for similar scholarship button click'
export const SAVE_SIMILAR_SCHOLARSHIP_CLICK = 'Save similar scholarship click'

export const REQUIREMENT_UPLOADED = 'Requirement Uploaded'
export const REQUIREMENT_COMPLETED = 'Requirement Completed'
/**
 * @deprecated https://app.clickup.com/t/36184932/SD-8000
 */
export const APPLICATION_STARTED = 'Application Started'
export const APPLICATION_REVIEW_SCREEN_VIEW = 'Application review screen view'
export const CONFIRM_SEND_APPLICATION_BUTTON_CLICK = 'Confirm&send application button click'
export const PROFILE_AREA_HYPERLINK_CLICK = 'Profile area hyperlink click'
export const PROFILE_UPDATED = 'Profile updated'
export const APPLICATION_PREVIEW_REQ_VIEW = 'Requirement Viewed Application Review'
export const APPLICATION_PREVIEW_REQ_DOWNLOAD = 'Requirement Downloaded Application Review'
export const CATEGORY_FILTER_APPLIED = 'Category filter applied'

// freemium modal events
export const UPGRADE_PRO_MODAL_VIEW = 'Upgrade pro modal view [Freemium]'
export const UPGRADE_PRO_PLAN_CLICK = 'Upgrade to Pro plan click [Freemium]'
export const PRO_CHANCES_CLICK = 'I’ll take my chances click [Freemium]'
export const UNLOCK_PRO_BUTTON_CLICK = 'Unlock pro button click [Freemium]'
export const UNLOCK_PRO_SIMILARITY_CLICK = 'Unlock Pro Similarity click [Freemium]'
export const UNLOCK_STATUSES_CLICK = 'Unlock statuses click [Freemium]'
export const UNLOCK_PRO_RECOMMENDED_CLICK = 'Unlock Pro Recommended click [Freemium]'
export const UNLOCK_AUTOMATIC_CLICK = 'Unlock automatic click [Freemium]'
export const TOOLTIP_VIEW = 'Tooltip view [Freemium]'
export const UNLOCK_PRO_BUTTON_CLICK_TOOLTIP = 'Unlock Pro button click tooltip [Freemium]'
export const CLOSED_SUB_TAB_VIEW = 'Closed subtab view'
export const ACTIVE_SUB_TAB_VIEW = 'Active subtab view'
export const UNLOCK_PRO_BUTTON_CLICK_NAVIGATION = 'Unlock pro button click navigation [Freemium]'
export const UNLOCK_APPLY_SIMILARITY_BUTTON_CLICK = 'Unlock to apply Similarity button click [Freemium]'
export const FREEMIUM_RECOMMENDER_UNLOCK_PRO_BUTTON_CLICK = 'Freemium recommender unlock pro button click'
export const GO_BACK_TO_BROWSING_MATCHES = 'Go back to browsing matches'

// cancelation package subscription events
export const CANCELATION_MODAL_VIEW = 'Cancelation modal view'
export const ACCEPT_OFFER_BUTTON_CLICK = 'Accept offer button click'
export const CANCEL_SUBSCRIPTION_MODAL_VIEW = 'Cancel subscription modal view'
export const CANCEL_SUBSCRIPTION_BUTTON_CLICK_MODAL = 'Cancel subscription button click [Modal]'

// application details
export const DOWNLOAD_SUBMITTED_REQUIREMENT = 'Download submitted requirement'
export const VIEW_SUBMITTED_REQUIREMENT = 'View submitted requirement'
export const VISIT_SUBMITTED_LINK_BUTTON = 'Visit submitted link button click'
export const PAYOUT_TOOLTIP_VIEW = 'Payout tooltip view'

// Gamificaiton
export const SET_GOAL_BUTTON_CLICK = 'Set goal button click'
export const NEW_STREAKS_ICON_CLICK = 'New streaks icon click'
export const LEVEL_GAMEBAR_CLICK = 'Level gamebar click'
export const LEVEL_GAMEBAR_OPEN_BUTTON_CLICK = 'Level gamebar open button click'
export const CHANGE_TAB = 'Change Tab'

export const PAGE_VIEW = 'pageView'
export const IMPRESSION_TRACKING = 'Impression'
export const GET_RESOURCE_BC = 'Get resource button click'

// payment modal
export const BRAINTREE_PAYPAL_CLICK = 'BraintreePaypal click'
export const PACKAGE_BUTTON_CLICK = 'PackageButton click'

// Maintenance mode events
export const ACCEPT_MAINTENANCE_BUTTON_CLICK = 'Accept maintenance button click'
export const REACTIVATE_PRO_PLAN_CLICK = 'Reactivate pro plan click [Maintenance]'
export const REACTIVATE_PRO_BUTTON_CLICK_NAVIGATION = 'Reactivate pro button click navigation [Maintenance]'
export const REACTIVATE_PRO_BUTTON_CLICK_DETAILS = 'Reactivate pro button click details [Maintenance]'
export const REACTIVATE_PRO_RECOMMENDED_CLICK = 'Reactivate Pro Recommended click [Maintenance]'
export const TOOLTIP_VIEW_MAINTENANCE_MODE = 'Tooltip view [Maintenance]'
export const REACTIVATE_PRO_MODAL_VIEW = 'Reactivate pro modal view [Maintenance]'
export const MAINTENANCE_MODAL_VIEW = 'Maintenance modal view'
export const DECLINE_OFFER_BUTTON_CLICK = 'Decline offer button click'
export const DECLINE_MAINTENANCE_BUTTON_CLICK = 'Decline maintenance button click'

// Easy scholarship events
export const APPLY_ALL_BUTTON_CLICK = 'Apply all button click'
export const SELECT_ALL_EASY_SCHOLARSHIPS_BUTTON_CLICK = 'Select all easy scholarships button click'
export const DESELECT_EASY_SCHOLARSHIP_CLICK = 'Deselect easy scholarship click'

// engagement modal
export const NO_ENGAGEMENT_SURVEY_BTN_CLICK = 'No engagement survey button click'

// Goal requirement
export const COMPLETE_GOAL_REQUIREMENT_CLICK = 'Complete goal requirement button click'
export const VERIFY_GOAL_REQUIREMENT_CLICK = 'Verify goal requirement button click'

export const SIMILARITY_SCREEN_VIEW = 'Similarity screen view'
export const UPGRADE_UNLOCK_BLURRED_BUTTON_CLICK = 'Upgrade to unlock blurred button click'
export const APPLY_EXTERNALLY_BUTTON_CLICK = 'Apply externally button click'
export const UNLOCK_TO_APPLY_DIRECTLY_BUTTON_CLICK = 'Unlock to apply directly button click'
export const PRO_MODAL_CAROUSEL_CLICK = 'Pro modal carousel click'
export const UNLOCK_CREDIBILITY_SCORES_BUTTON_CLICK = 'Unlock credibility scores button click'
export const UNLOCK_STATUSES_BUTTON_CLICK = 'Unlock statuses button click'
export const NO_THANKS_STATUS_BUTTON_CLICK = 'No, thanks button click'
export const CONTINUE_WITH_FREEMIUM_BUTTON_CLICK = 'Continue with Freemium button click'
export const CONTINUE_WITH_FREEMIUM_BUTTON_IMPRESSION = 'Continue with Freemium button impression'
export const FREEMIUM_PAYWALL_POPUP_OPEN = 'Freemium paywall popup open'
export const FREEMIUM_PAYWALL_ACCEPT_OFFER_CTA_CLICK = 'Freemium paywall accept offer CTA click'
export const ACTIVATION_MODAL_OPEN = 'Activation modal open'
export const ACTIVATION_MODAL_SKIP = 'Activation modal skip'
export const ACTIVATION_MODAL_APPLY_BUTTON_CLICK = 'Activation modal apply button click'
export const AUTOMATIC_APPLICATION_MODAL_OPEN = 'Automatic application modal open'
export const AUTOMATIC_APPLICATION_MODAL_YES_BUTTON_CLICK = 'Automatic application modal yes button click'
export const AUTOMATIC_APPLICATION_MODAL_NO_BUTTON_CLICK = 'Automatic application modal no button click'
export const PROVIDER_SOCIAL_LINK_CLICK = 'Provider social link click'
export const PROVIDER_MISSION_SHOW_MORE_CLICK = 'Provider mission show more click'
export const QUICK_UPDATE = 'Quick Update'
export const HEADER_WINNERS_BUTTON_CLICK = 'Dashboard header winners button click'
export const ELB_SECTION_LOADED = 'Scholarship eligibility criteria section loaded'
export const ELB_SECTION_SHOWN = 'Scholarship eligibility criteria section shown'
export const NEWS_TICKER_CLOSED = 'Dashboard News Ticker Close Button Click'
export const NEWS_TICKER_TOGGLED = 'Dashboard News Ticker User Menu Toggle Button Click'
export const WINNER_BLAST_SHOWN = 'Dashboard Winner Blast Shown'
export const WINNER_BLAST_DISMISSED = 'Dashboard Winner Blast Dismissed'
export const WINNER_BLAST_REACTED = 'Dashboard Winner Blast Reaction Button Click'
export const WINNER_BLAST_VIDEO_PLAYED = 'Dashboard Winner Blast Video Play Button Click'
export const WINNER_BLAST_VIDEO_PAUSED = 'Dashboard Winner Blast Video Pause Button Click'
export const PREVIOUS_WINNERS_LOADED = 'Dashboard Previous Winners Loaded'
export const PREVIOUS_WINNERS_SECTION_SHOWN = 'Dashboard Previous Winners Section Shown'
export const PREVIOUS_WINNERS_VIDEO_PLAYED = 'Dashboard Previous Winners Section Video Play Button Click'
export const PREVIOUS_WINNERS_VIDEO_PAUSED = 'Dashboard Previous Winners Section Video Pause Button Click'
export const PREVIOUS_WINNERS_SHOW_MORE_CLICK = 'Dashboard Previous Winners Section Show More Button Click'
export const PREVIOUS_WINNERS_SHOW_LESS_CLICK = 'Dashboard Previous Winners Section Show Less Button Click'
export const PREVIOUS_WINNERS_NAV_BUTTON_CLICK = 'Dashboard Previous Winners Section Navigation Button Click'
export const CUSTOMER_PORTAL_LINK_CLICKED = 'Customer portal link click'
export const PROVIDER_STATISTICS_LOADED = 'Dashboard Provider Statistics Loaded'
export const APPLICATION_STATUS_TOOLTIP_SHOWN = 'Application status tooltip shown'
export const REFERRAL_INTRO_POPUP_OPENED = 'Referral Intro Popup Opened'
export const REFERRAL_INTRO_POPUP_CTA_CLICKED = 'Referral Intro Popup CTA Clicked'
export const CAP_SCHOLARSHIP_VIEWED = 'Cap Scholarship Viewed'
export const GUEST_GIFT_CTA_CLICKED = 'Guest Gift CTA Clicked'
export const GUEST_GIFT_POPUP_CLOSED = 'Guest Gift Popup Closed'
export const GUEST_GIFT_LINK_COPIED = 'Guest Gift Link Copied'
export const TRIAL_EXTENSION_CTA_CLICKED = 'Trial Extension CTA Clicked'
export const TRIAL_EXTENSION_POPUP_OPENED = 'Trial Extension Popup Opened'
export const TRIAL_EXTENSION_POPUP_CLOSED = 'Trial Extension Popup Closed'
export const TRIAL_EXTENSION_LINK_COPIED = 'Trial Extension Link Copied'
export const TRIAL_EXTENSION_SUCCESS_POPUP_OPENED = 'Trial Extension Success Popup Opened'

export interface TrialExtensionPopupOpenedEvent {
  Source: 'auto' | 'cta'
}
